// Crear opción inicial
const createInitOption = (selectElement, lang) => {
  const optionElement = document.createElement('option');
  const options = {
    selected: true,
    disabled: true,
    value:"",
    text: lang === 'es' ? 'Seleccione una opción' : 'Select option'
  };
  Object.assign(optionElement, options);
  selectElement.appendChild(optionElement);
};

// Agregar opciones al select
const addOptionsToSelect = (data, selectElement) => {
  data.industries.forEach(industry => {
    const optgroup = document.createElement('optgroup');
    optgroup.label = industry.category;

    const optionElements = industry.options.map(option => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.text = option.name;
      return optionElement;
    });

    optgroup.append(...optionElements);
    selectElement.appendChild(optgroup);
  });
};

export const initSelectIndustrias = async (selectElement, lang) => {
  try {
    createInitOption(selectElement, lang);
    // Cargar el archivo JSON según el idioma seleccionado
    const fileName = lang === 'es' ? '/wp-content/themes/doppler-webpack/js/json/listado_industrias_es.json' : '/wp-content/themes/doppler_site/assets/js/register-forms/listado_industrias_en.json';
    const response = await fetch(`${fileName}`);
    const data = await response.json();
    addOptionsToSelect(data, selectElement);
  } catch (error) {
    console.log(error);
  }
};
